/**
 * Manages overlapping requests by canceling the previous one.
 */
export class AbortManager {
	private controller: AbortController | null = null;

	/**
	 * Cancels the previous request, if any, and creates a new `AbortController`.
	 *
	 * @returns The `AbortSignal` of the newly created `AbortController`.
	 */
	public createAbortSignal(): AbortSignal {
		if (this.controller) this.controller.abort(); // Cancel the previous request
		this.controller = new AbortController(); // Create a new controller
		return this.controller.signal; // Return the signal for the new request
	}

	/**
	 * Cancels the current request, if any.
	 */
	public cancelCurrentRequest(): void {
		if (this.controller) {
			this.controller.abort();
			this.controller = null;
		}
	}
}
